module.exports = __webpack_public_path__ + "3c45b6bb5cebc0802058033b92b678fb.svg";